import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IOurTeamPhotosLinkProps } from '../components/our-team-photos-link/our-team-photos-link';

export class OurTeamPhotosLinkModel extends ContentItem {
  get ctaText(): string | null {
    return get(this._config, 'elements.call_to_action_text.value', null);
  }
  get internalLinktoSection(): string | null {
    return get(
      this._config,
      'elements.link_to_internal_section.value[0].elements.page.value[0].elements.basic_page_settings__url.value',
      null
    );
  }

  get allEmployeePhotos(): string[] {
    const getEmployees = get(
      this._config,
      'elements.employees_collection.value[0].elements.collection_of_employees.value',
      []
    );

    const arrayOfAvatars: string[] = [];

    getEmployees.map((person: IEmployeeBox, i: number): string => {
      const getPhoto = get(person, 'elements.photo.value[0].url', null);
      return getPhoto ? (arrayOfAvatars[i] = getPhoto) : ' ';
    });

    return arrayOfAvatars;
  }

  public static create(data: IOurTeamPhotosLink): IOurTeamPhotosLinkProps {
    const {
      ctaText,
      internalLinktoSection,
      allEmployeePhotos
    } = new OurTeamPhotosLinkModel(data);
    return {
      ctaText,
      internalLinktoSection,
      allEmployeePhotos
    };
  }
}
